import React from 'react';
import PropTypes from 'prop-types';
import { Inline } from '@styleseat/ui';
import { ModalTrigger } from '../../../ui';
import GlyphIcon, { TRASH_CAN } from '../../../ui/GlyphIcon';
import DeleteConfirmationModal from '../ProviderProductUI/DeleteConfirmationModal';
import { ProviderProductForm } from '../ProviderProductForm/ProviderProductForm';
import { ProviderProductPropType } from '../ProfilePropTypes';
import analytics from '../../../../modules/analytics';
import './CardButton.module.scss';
import CardEditButton from './CardEditButton';

export default function CardEditDeleteButtons({
  onEditItem,
  onDelete,
  product,
}) {
  return (
    <Inline alignItems="center">
      <ModalTrigger
        renderTrigger={open => {
          const handleOpen = () => {
            open();
            analytics.track('pro_clicked_delete_product');
          };
          return (
            <GlyphIcon
              content={TRASH_CAN}
              styleName="trash-icon"
              onPress={handleOpen}
            />
          );
        }}
        renderModal={close => (
          <DeleteConfirmationModal onDelete={onDelete} close={close} />
        )}
      />
      <ModalTrigger
        renderTrigger={open => {
          const handleOpen = () => {
            open();
            analytics.track('pro_clicked_edit_product');
          };
          return <CardEditButton onEdit={handleOpen} />;
        }}
        renderModal={close => (
          <ProviderProductForm
            onSaveProduct={onEditItem}
            onClose={close}
            product={product}
          />
        )}
      />
    </Inline>
  );
}

CardEditDeleteButtons.propTypes = {
  onDelete: PropTypes.func,
  onEditItem: PropTypes.func,
  product: ProviderProductPropType.isRequired,
};

CardEditDeleteButtons.defaultProps = {
  onDelete: null,
  onEditItem: null,
};
